import TMWingsAnimation from '@/Components/Animations/TMWingsAnimation/TMWingsAnimation';
import TypingTextAnimation from '@/Components/Animations/TypingTextAnimation';
import UIStrings from '@/Utils/UIStrings';

function WingsIcon() {
    return (
        <div
            data-cy="JobAdTitleGenerationLoadingOverlay"
            className="pointer-events-none absolute inset-y-0 left-0 flex h-10 w-full items-center justify-start gap-1 px-3 py-2"
        >
            <TMWingsAnimation width="28px" height="28px" />
            <TypingTextAnimation deletionSpeed={20} texts={[UIStrings.GeneratingJobAdTitleWithAI]} />
        </div>
    );
}

export default WingsIcon;
